import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const ArrowQuickToolsSvg = () => (
  <svg width='9' height='14' viewBox='0 0 9 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.5 13L7.5 7L1.5 1'
      stroke='#2C3B38'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ArrowQuickToolsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ArrowQuickToolsSvg} {...props} />
);
